// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const YAxisLeftRightIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="YAxisLeftRightIcon" ref={forwardedRef} {...props}>
      <path d="M15.5 3v14h.75a1 1 0 0 0 1-1V3z" />
      <path d="M4.5 3v14H3.75a1 1 0 0 1-1-1V3z" />
      <path d="M12.25 15.5h1.5V17h-1.5z" />
      <path d="M10.75 15.5h-1.5V17h1.5z" />
      <path d="M6.25 15.5h1.5V17h-1.5z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const YAxisLeftRightIcon = /* @__PURE__ */ Object.assign(
  YAxisLeftRightIconComponent,
  { displayName: 'YAxisLeftRightIcon' },
);
